// import { useState } from "react";
import { useAppSelector } from "../../../store/store";
import Loading from "./Loading";
// import { useApp } from "../../../shared/AppProvider/AppProvider";

const GlobalLoadingOverlay = () => {
  const isLoading = useAppSelector((state) => state.common.is_page_loading);
  // const [opacity, setOpacity] = useState(0); // start fully transparent
  // const { isDarkMode } = useApp();

  // useEffect(() => {
  //   let interval:  ReturnType<typeof setInterval>;

  //   if (isLoading) {
  //     setOpacity(0.5); // start strong
  //     interval = setInterval(() => {
  //       setOpacity((prev) => {
  //         const next = prev - 0.01; // reduce step
  //         return next > 0.05 ? next : 0.05; // don't go below 0.05
  //       });
  //     }, 10); // every 10ms
  //   } else {
  //     setOpacity(0); // hide immediately
  //   }

  //   return () => clearInterval(interval);
  // }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-3xl"
      style={{
        // backgroundColor: isDarkMode
        //   ? `rgba(17, 24, 39, ${opacity})` // dark:bg-gray-900 ~ rgb(17,24,39)
        //   : `rgba(255, 255, 255, ${opacity})`, // light mode
        transition: "background-color 0.1s linear",
      }}
    >
      <Loading />
    </div>
  );
};

export default GlobalLoadingOverlay;
